import { Server, IRetryInfo } from '@/app-modules/server-communications';
import { IServerServiceStreamProperties } from './server-service-stream-properties';

class ChatModsServer<T extends IServerServiceStreamProperties> extends Server<IServerServiceStreamProperties> {
    public streams: T;

    public connect(retryInfo?: IRetryInfo): Promise<any> {
        return super.connect(retryInfo);
    }
}

export { ChatModsServer };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-service/chatmods-server.ts